/* Quiz síntoma-producto MUVO (v1). Custom Shopify section state machine.
 * Spec: quiz-spec-v1.md. Hydration: Storefront /products/{handle}.js.
 * AJAX cart: /cart/add.js. UTM: onsite / quiz / sintoma-producto.
 */
(function () {
  const root = document.querySelector('[data-quiz-root]');
  if (!root) return;

  const config = JSON.parse(root.querySelector('[data-quiz-config]').textContent);
  const state = { answers: {}, currentIdx: 0, questionOrder: [] };
  const screens = {
    hero: root.querySelector('[data-screen="hero"]'),
    question: root.querySelector('[data-screen="question"]'),
    email: root.querySelector('[data-screen="email"]'),
    result: root.querySelector('[data-screen="result"]'),
  };

  function show(name) {
    Object.entries(screens).forEach(([k, el]) => { el.hidden = k !== name; });
  }

  function buildOrder() {
    state.questionOrder = config.questions.filter((q) => {
      if (!q.skipIf) return true;
      return !Object.entries(q.skipIf).some(([k, vals]) => vals.includes(state.answers[k]));
    });
  }

  function isOptionAllowed(opt) {
    if (!opt.showIf) return true;
    return Object.entries(opt.showIf).every(([k, vals]) => vals.includes(state.answers[k]));
  }

  function renderQuestion() {
    const q = state.questionOrder[state.currentIdx];
    if (!q) return goToEmail();
    root.querySelector('[data-question]').textContent = q.text;
    const total = state.questionOrder.length;
    root.querySelector('[data-progress]').style.width = `${((state.currentIdx + 1) / total) * 100}%`;
    root.querySelector('[data-progress-label]').textContent = `${state.currentIdx + 1}/${total}`;
    const opts = root.querySelector('[data-options]');
    opts.innerHTML = '';
    q.options.filter(isOptionAllowed).forEach((o) => {
      const btn = document.createElement('button');
      btn.className = 'muvo-quiz__option';
      if (o.icon) {
        const iconImg = document.createElement('img');
        iconImg.className = 'muvo-quiz__option-icon';
        iconImg.src = o.icon;
        iconImg.alt = '';
        btn.appendChild(iconImg);
      }
      const labelSpan = document.createElement('span');
      labelSpan.className = 'muvo-quiz__option-label';
      labelSpan.textContent = o.label;
      btn.appendChild(labelSpan);
      btn.dataset.value = o.value;
      btn.addEventListener('click', () => selectOption(q.id, o.value, btn));
      opts.appendChild(btn);
    });
    root.querySelector('[data-action="next"]').disabled = !state.answers[q.id];
    show('question');
  }

  function selectOption(qid, value, btn) {
    state.answers[qid] = value;
    btn.parentElement.querySelectorAll('.muvo-quiz__option').forEach((el) => el.classList.remove('is-selected'));
    btn.classList.add('is-selected');
    root.querySelector('[data-action="next"]').disabled = false;
    buildOrder();
  }

  function next() {
    state.currentIdx += 1;
    if (state.currentIdx >= state.questionOrder.length) return goToEmail();
    renderQuestion();
  }

  function back() {
    if (state.currentIdx === 0) return show('hero');
    state.currentIdx -= 1;
    renderQuestion();
  }

  function goToEmail() { show('email'); }

  function submitEmail() {
    const email = root.querySelector('[data-email-input]').value.trim();
    if (email) state.answers.email = email;
    resolveAndShowResult();
  }

  function skipEmail() { resolveAndShowResult(); }

  function matchMapping() {
    const key = ['sintoma', 'intensidad', 'formato', 'experiencia']
      .map((k) => state.answers[k] || '*')
      .join('.');
    // Exact match first, then wildcard match
    const exact = config.mapping.find((m) => m.k === key);
    if (exact) return exact;
    const wildcard = config.mapping.find((m) => {
      const parts = m.k.split('.');
      const keyParts = key.split('.');
      return parts.every((p, i) => p === '*' || p === keyParts[i]);
    });
    return wildcard || { primary: config.fallback };
  }

  async function fetchProduct(handle) {
    if (!handle) return null;
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return null;
      return await res.json();
    } catch (_e) { return null; }
  }

  function renderProductCard(container, product, label) {
    if (!product) { container.hidden = true; return; }
    container.hidden = false;
    container.innerHTML = `
      ${label ? `<p class="muvo-quiz__complement-label">${label}</p>` : ''}
      <div class="muvo-quiz__product-img-wrap">
        <img class="muvo-quiz__product-img" src="${product.featured_image}" alt="${product.title}">
      </div>
      <h3 class="muvo-quiz__product-title">${product.title}</h3>
      <p class="muvo-quiz__product-price">$${(product.price / 100).toLocaleString('es-MX', { minimumFractionDigits: 0 })} MXN</p>
      <p class="muvo-quiz__product-desc">${(product.description || '').replace(/<[^>]+>/g, '').substring(0, 140)}...</p>
    `;
    container.dataset.variantId = product.variants[0].id;
  }

  async function resolveAndShowResult() {
    const match = matchMapping();
    const [primary, complement] = await Promise.all([
      fetchProduct(match.primary),
      match.complement ? fetchProduct(match.complement) : null,
    ]);
    renderProductCard(root.querySelector('[data-product-primary]'), primary);
    renderProductCard(root.querySelector('[data-product-complement]'), complement, 'Complementa con:');
    show('result');
    trackCompletion(match);
  }

  async function addToCart() {
    const primaryId = root.querySelector('[data-product-primary]').dataset.variantId;
    const complementId = root.querySelector('[data-product-complement]').dataset.variantId;
    const items = [{ id: parseInt(primaryId, 10), quantity: 1 }];
    if (complementId) items.push({ id: parseInt(complementId, 10), quantity: 1 });
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
      window.location.href = '/cart?utm_source=onsite&utm_medium=quiz&utm_campaign=sintoma-producto';
    } catch (e) {
      console.error('cart add failed', e);
    }
  }

  function trackCompletion(match) {
    track('quiz_completion', {
      primary: match.primary,
      complement: match.complement || null,
      sintoma: state.answers.sintoma || null,
      intensidad: state.answers.intensidad || null,
      formato: state.answers.formato || null,
      experiencia: state.answers.experiencia || null,
    });
  }

  function restart() {
    state.answers = {};
    state.currentIdx = 0;
    show('hero');
  }

  function track(eventName, params) {
    if (window.gtag) {
      try { window.gtag('event', eventName, params || {}); } catch (e) {}
    }
    if (window.dataLayer) {
      try { window.dataLayer.push({ event: eventName, ...(params || {}) }); } catch (e) {}
    }
  }

  root.addEventListener('click', (e) => {
    const action = e.target.dataset.action;
    if (!action) return;
    if (action === 'start') {
      track('quiz_start', { page: 'encuentra-tu-muvo' });
      buildOrder(); state.currentIdx = 0; renderQuestion();
    }
    if (action === 'next') {
      const q = state.questionOrder[state.currentIdx];
      track('quiz_question_answered', { question_id: q ? q.id : null, answer: q ? state.answers[q.id] : null, position: state.currentIdx + 1 });
      next();
    }
    if (action === 'back') { back(); }
    if (action === 'submit-email') {
      const emailInput = root.querySelector('[data-email-input]');
      const hasEmail = emailInput && emailInput.value && emailInput.value.trim();
      track('quiz_email_captured', { with_email: !!hasEmail });
      submitEmail();
    }
    if (action === 'skip-email') {
      track('quiz_email_skipped', {});
      skipEmail();
    }
    if (action === 'add-to-cart') {
      const primaryId = root.querySelector('[data-product-primary]').dataset.variantId;
      const complementId = root.querySelector('[data-product-complement]').dataset.variantId;
      track('quiz_cart_add', { primary_variant: primaryId, complement_variant: complementId || null });
      addToCart();
    }
    if (action === 'restart') {
      track('quiz_restart', {});
      restart();
    }
  });
})();
